import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { useConfiguration } from '@/composables/useConfigration';
import { AuthService } from './services/AuthService';

export class Http {
  private readonly configuration = useConfiguration();
  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: this.configuration.API_URL,
    });

    this.client.interceptors.request.use(async (config) => {
      const token = await AuthService.instance.getAccessToken();

      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["X-Request-ID"] = this.generateUUID();

      return config;
    });
  }

  public apiServer(): AxiosInstance {
    return this.client;
  }

  public async apiServerBlobClient(): Promise<AxiosInstance> {
    const token = await this.getToken();
    return axios.create({
      baseURL: this.configuration.API_URL,
      responseType: "blob",
      headers: {
        Authorization: token,
        "X-Request-ID": this.generateUUID(),
      },
    });
  }

  public async publicDirectoryBlobClient(): Promise<AxiosInstance> {
    const token = await this.getToken();
    return axios.create({
      baseURL: window.location.origin,
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    });
  }

  public custom(configuration: AxiosRequestConfig): AxiosInstance {
    return axios.create(configuration);
  }

  protected async getToken(): Promise<string> {
    return await AuthService.instance.getAccessToken().then(t => `Bearer ${t}`);
  }

  protected generateUUID(): string {
    const uuid = self.crypto.randomUUID();
    return uuid;
  }
}
